module.exports = __webpack_public_path__ + "joy-static/media/joy-to-the-world.0ba31234.png";